import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { authAxiosWithoutInterceptors } from "./axios";

export enum ResetPasswordType {
  CREATE_PASSWORD = "createPassword",
  RESET_PASSWORD = "resetPassword",
}

export interface IGetRegisterExpiredParams {
  userId: ObjectId;
  code: string;
  type: ResetPasswordType;
}

export const useGetRegisterExpired = () => {
  const [state, execute, cancel] = authAxiosWithoutInterceptors<void, void, unknown>(
    {
      url: "/password/register/expired",
      method: "GET",
    },
    { manual: true }
  );

  const callback = useCallback(
    (params: IGetRegisterExpiredParams) => {
      return execute({
        params,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
